<template>
  <Button v-if="showByNoPermission||ifShow" v-bind="getBindValue" :class="getButtonClass" @click="onClick">
    <template #default="data">
      <Icon :icon="preIcon" v-if="preIcon" :size="iconSize" />
      <slot v-bind="data || {}"></slot>
      <Icon :icon="postIcon" v-if="postIcon" :size="iconSize" />
    </template>
  </Button>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { usePermission } from '/@/hooks/web/usePermission';     
  import { computed, unref } from 'vue';
  import { Button } from 'ant-design-vue';
  import Icon from '/@/components/Icon/src/Icon.vue';
  import { buttonProps } from './props';

  export default defineComponent({
    name: 'AButton',
    components:{Button,Icon},
    props:buttonProps,
    setup(props, {attrs}){
      const getButtonClass = computed(() => {
        const { color, disabled } = props;
        return [
          {
            [`ant-btn-${color}`]: !!color,
            [`is-disabled`]: disabled,
          },
        ];
      });
      const { hasPermission } = usePermission();
      const ifShow = hasPermission(props.auth);

      // get inherit binding value
      const getBindValue = computed(() => {
        return { 
          ...unref(attrs), 
          ...props,
          disabled:props.disabled||(props.showByNoPermission&&!hasPermission(props.auth))
        }
      });

      return {
        ifShow,
        getButtonClass,
        getBindValue,
      }
    }
  });
</script>
